import { EmptyState, NoDataIcon, PageHeader } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Spinner } from '../../../../components/generic'
import useFilterParamsGeneric from '../../../../hooks/useFilterParamsGeneric'
import { useRouter } from '../../../../hooks/useRouter'
import { goalReportsConstants } from '../../../../locale/goalReports'
import { TitleContainer } from '../../../Logs/LogScreen/components/IncidentLogScreens/components/display/commonStyledComponents'
import { GoalFilters, type SetFilterParams } from './components/GoalFilters'
import GoalReportsSection from './components/GoalReportsSection'
import { useGoalsReportList } from './hooks/useGoalsReportList'
import type { FilterValues } from './types'

export const GoalsManagement = ({ testId }: { testId?: string } = {}) => {
  const { t } = useTranslation(NAMESPACE.GOAL_REPORTS)
  const { location } = useRouter()

  const initialFiltersValue = {
    residents: [],
    goalStatuses: [],
    reviewStatuses: []
  }
  const { filterParamsGeneric, setFilterParams } =
    useFilterParamsGeneric(initialFiltersValue)

  useEffect(() => {
    if (location?.state?.reviewStatus) {
      setFilterParams((prev) => ({
        ...prev,
        reviewStatuses: location.state.reviewStatus
      }))
    }
  }, [location?.state])

  const filterParams = filterParamsGeneric as FilterValues

  const { data, isLoading } = useGoalsReportList(filterParams as FilterValues)

  const baseId = testId || 'goals-management'

  return (
    <MainContainer data-testid={baseId}>
      <PageHeader
        title={
          <TitleContainer>
            {t(goalReportsConstants.GOAL_MANAGEMENT)}
          </TitleContainer>
        }
        data-testid={`${baseId}-header`}
      />
      <GoalFilters
        filterParams={filterParams}
        setFilterParams={setFilterParams as unknown as SetFilterParams}
        testId={baseId}
      />
      {isLoading ? (
        <Spinner data-testid={`${baseId}-loading`} />
      ) : (
        <SectionsContainer data-testid={`${baseId}-sections`}>
          {data?.length ? (
            data?.map((residentGoalData) => {
              return (
                <GoalReportsSection
                  data={residentGoalData}
                  key={residentGoalData?.id}
                  testId={baseId}
                />
              )
            })
          ) : (
            <EmptyState
              title={t(goalReportsConstants.EMPTY_STATE)}
              icon={<NoDataIcon />}
              data-testid={`${baseId}-empty-state`}
            />
          )}
        </SectionsContainer>
      )}
    </MainContainer>
  )
}

const MainContainer = styled.div`
  max-width: 1080px;
  margin: 24px;
  display: flex;
  gap: 24px;
  flex-direction: column;
`
const SectionsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
  flex-direction: column;
`
export default GoalsManagement
